import { enGB, enUS } from 'date-fns/locale';
export var getDateFnsLocale = function (locale) {
    if (locale === 'en-GB') {
        return enGB;
    }
    else {
        return enUS;
    }
};
// Date format
export var getDateFnsLocaleDateFormat = function (locale) { var _a; return (_a = getDateFnsLocale(locale).formatLong) === null || _a === void 0 ? void 0 : _a.date({ width: 'short' }); };
// Time format
export var getDateFnsLocaleTimeFormat = function (locale) {
    var _a;
    var formatString = (_a = getDateFnsLocale(locale).formatLong) === null || _a === void 0 ? void 0 : _a.time({ width: 'medium' });
    // Add leading zero
    if (formatString.startsWith('h:')) {
        formatString = 'h'.concat(formatString);
    }
    return formatString;
};
//# sourceMappingURL=index.js.map